import { useState } from 'react';

const SAMPLE_PROMPTS = [
  'calculate CO2 intensity per kg of product for this stream',
  'sum of mass flows for methane, ethane, and propane',
  'vapor-phase mass flow with a guard for solver iteration',
];

interface Props {
  onGenerate: (description: string) => void;
  disabled: boolean;
}

export function GeneratorForm({ onGenerate, disabled }: Props): JSX.Element {
  const [description, setDescription] = useState('');

  const handleSubmit = (e: React.FormEvent): void => {
    e.preventDefault();
    if (description.trim().length < 10) return;
    onGenerate(description.trim());
  };

  const canSubmit = description.trim().length >= 10 && !disabled;

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4 flex-1">
      <label className="flex flex-col gap-2">
        <span className="text-sm text-neutral-400">
          Describe the User Variable you want
        </span>
        <textarea
          autoFocus
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          className="w-full min-h-[140px] bg-bg-elevated border border-border-subtle rounded-md p-3 text-sm focus:outline-none focus:border-accent resize-y"
          placeholder="e.g. calculate CO2 intensity per kg of product"
          disabled={disabled}
        />
      </label>

      <button type="submit" className="btn-primary" disabled={!canSubmit}>
        {disabled ? 'Generating…' : 'Generate UV'}
      </button>

      <div className="mt-2">
        <p className="text-xs text-neutral-500 mb-2">Or try a sample prompt:</p>
        <div className="flex flex-col gap-2">
          {SAMPLE_PROMPTS.map((p) => (
            <button
              type="button"
              key={p}
              className="text-left text-sm text-neutral-300 bg-bg-elevated border border-border-subtle rounded-md px-3 py-2 hover:border-accent hover:text-accent transition-colors"
              onClick={() => setDescription(p)}
              disabled={disabled}
            >
              {p}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-auto pt-4 border-t border-border-subtle text-xs text-neutral-500">
        v0 targets MaterialStream objects on HYSYS V14. Advanced options will arrive in v1.
      </div>
    </form>
  );
}
